var getElOffset = function getElOffset(el) {
  if (typeof document === "undefined" || typeof window === "undefined") return [];
  var rect = el.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return [rect.left + scrollLeft, rect.top + scrollTop];
};

export default getElOffset;